module.exports = __webpack_public_path__ + "img/pencil.832599ca.svg";